export const anchorLinks = [
  {
    anchor: 'about',
    alias: '/#about',
    title: 'About the program',
  },
  {
    anchor: 'requirements',
    alias: '/#requirements',
    title: 'Requirements',
  },
  {
    anchor: 'testimonials',
    alias: '/#testimonials',
    title: 'Testimonials',
  },
];

export const anchorLinksFormPage = [
  {
    anchor: 'personal',
    alias: '#personal',
    title: 'Personal information',
  },
  {
    anchor: 'about',
    alias: '#about',
    title: 'About yourself',
  },
  {
    anchor: 'contact',
    alias: '#contact',
    title: 'Contact information',
  },
];
